export const right = {
	ADMIN: 'ADMIN',
	PARTY_NEW: 'PARTY_NEW',
	PARTY_EDIT: 'PARTY_EDIT',
	PARTY_DELETE: 'PARTY_DELETE',
	INVOICE_NEW: 'INVOICE_NEW',
	INVOICE_EDIT: 'INVOICE_EDIT',
	INVOICE_DELETE: 'INVOICE_DELETE',
	USER_NEW: 'USER_NEW',
	USER_EDIT: 'USER_EDIT',
	USER_DELETE: 'USER_DELETE'
};

export const user = {
	CREATE: "CREATE",
	EDIT: "EDIT",
	DELETE: "DELETE"
};

export const party = {
	CREATE: "CREATE",
	EDIT: "EDIT",
	DELETE: "DELETE"
};

export const invoice = {
	CREATE: "CREATE",
	EDIT: "EDIT",
	DELETE: "DELETE"
};

export const transaction = {
	CREATE: "CREATE",
	EDIT: "EDIT",
	DELETE: "DELETE"
};

export const isAllowed = (session, r, r2) => {
	if (!session || !session.user.userId || !session.user.rights) {
		return false
	}

	return session.user.rights.indexOf(r) > -1
		|| (r2 && session.user.rights.indexOf(r2) > -1)
		|| session.user.rights.indexOf(right.ADMIN) > -1
};

export const isLoggedIn = (session) => {
	if (!session || !session.user.userId) {
		return false
	}

	return true
};

export const changedLoggedIn = (prevProps, nextProps) => {
	if (!isLoggedIn(prevProps.session) && isLoggedIn(nextProps.session)) {
		return true
	} else {
		return false
	}
};

export const hasAction = (item, action) => {
	if (!item || !item.actions) {
		return false
	}

	return item.actions.indexOf(action) > -1
};
